import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ContentSwitchItem } from './models/content-switch-item.model';
import { KhAnalyticsService } from 'app/shared/services/kh-analytics.service';

@Component({
    selector: 'kh-content-switch',
    styleUrls: ['./content-switch.component.less'],
    templateUrl: './content-switch.component.html',
    standalone: false
})
export class ContentSwitchComponent implements OnInit {

  public activeId = '';
  @Input() public options: ContentSwitchItem[] = [];
  @Input() public initialTrigger = false;
  @Input() public active = '';
  @Input() public trackingEvents: any = {};

  @Output() public select = new EventEmitter<string>();

  public constructor(private readonly khAnalyticsService: KhAnalyticsService) { }

  public ngOnInit(): void {

    if (this.options.length) {
      if (this.active) {
        this.activeId = this.active;
      } else {
        this.activeId = this.options[0].id;
      }

      if (this.initialTrigger) {
        this.selectOption(this.activeId);
      }
    }
  }

  public clickOption(optionId: string) {
    if (this.trackingEvents && this.trackingEvents[optionId]) {
      this.khAnalyticsService.trackEvent(this.trackingEvents[optionId]);
    }
    this.selectOption(optionId);
  }

  public selectOption(optionId: string) {
    this.activeId = optionId;
    this.select.emit(this.activeId);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.selectOption(this.active);
    }
  }
}
